<template>
  <div class="teaching-evaluate-apply-define-main">
    <div class="header">
      <div class="title">
        <TeachingEvaluateApplyDefineSetupSelect v-model="current"
                                                :evaluation="evaluation">
        </TeachingEvaluateApplyDefineSetupSelect>
      </div>
      <div v-if="current && current.isExist"
           class="extra">
        <el-button size="mini"
                   type="danger"
                   :disabled="cleaning"
                   @click="handleDefineClean">重置设置</el-button>
      </div>
    </div>
    <div class="body">
      <div class="body-cont"
           v-loading="cleaning"
           element-loading-text="数据重置中，请稍等...">
        <template v-if="current">
          <TeachingEvaluateApplyDefineMainWrap ref="wrap"
                                               :key="current.id"
                                               :evaluation="evaluation"
                                               :define-setup="current"></TeachingEvaluateApplyDefineMainWrap>
        </template>
        <template v-else>
          <Hint>
            <span>请先选择评教课程</span>
          </Hint>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../../elements/AppScrollbar'
import TeachingEvaluateApplyDefineSetupSelect from '../setup-select'
import TeachingEvaluateApplyDefineMainWrap from './wrap'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'TeachingEvaluateApplyDefineMain',
  components: {
    AppScrollbar,
    TeachingEvaluateApplyDefineSetupSelect,
    TeachingEvaluateApplyDefineMainWrap,
    Hint
  },
  props: {
    evaluation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      current: null,
      cleaning: false
    }
  },
  methods: {
    handleDefineClean () {
      const current = this.current
      if (current) {
        this.$confirm('重置操作将会清除配置的“评教指标”以及“评教内容”数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.cleaning = true
          this.$ajax({
            url: '/workspace/manager/teaching/evaluate/apply/define/submitClean',
            method: 'post',
            data: this.$qs.stringify({
              id: this.evaluation.id,
              courseId: current.id
            })
          }).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  this.$set(current, 'isExist', false)
                  this.$nextTick(() => {
                    const wrap = this.$refs.wrap
                    if (wrap) {
                      wrap.loadDefineQuotas()
                    }
                  })
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.cleaning = false
          })
        }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-apply-define-main {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 20px;
      border-bottom: 1px solid #ebeef5;
      & > .extra {
        margin-left: 15px;
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
